import React, {
    useState, useEffect, useImperativeHandle
} from 'react'
import {
    MDBCollapse, MDBBtn, MDBInput, MDBAlert,
} from "mdbreact"
import {Spinner} from 'reactstrap'
import {v4 as uuidv4} from 'uuid'
import classes from './ReportSection.module.css'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faChevronDown,
    faChevronUp,
    faCircle,
    faPlusCircle, faQuestion, faSortDown, faSortUp,
    faStar, faThumbsDown,
    faThumbsUp,
    faTimes
} from "@fortawesome/free-solid-svg-icons";
import firebase from "../../../../Config/firebase";
import DetailCard from "./DetailCard/DetailCard";
import Compressor from "compressorjs";
import {getDownloadLink, removeFileFromStorage} from '../../../../Utils/firebaseUtils'
import ContentLoader from "react-content-loader"
import ProgImg from "react-prog-img";

const db = firebase.firestore()

const ReportSection = (props, ref) => {
    const [isLoadedDetail, setIsLoadedDetail] = useState(false)
    const [detail, setDetail] = useState([])
    const [noItem, setNoItem] = useState(false)

    const [isCollapse, setIsCollapse] = useState(false)
    const [newFeatureText, setNewFeatureText] = useState('')
    const [sectionData, setSectionData] = useState({
        ListItem: [],
        topicName: '',
    })
    const [isCreateNewDetail, setIsCreateNewDetail] = useState(false)
    const [newDetail, setNewDetail] = useState({
        content: '',
        createDate: new Date(),
        createUserID: props.auth.uid,
        isAdmin: props.isAdmin,
        isUpvote: ''
    })

    const [isSubmitted, setIsSubmitted] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isError, setIsError] = useState(false)

    const [isUploading, setIsUploading] = useState(false)
    const [selectedFileList, setSelectedFileList] = useState([])

    const [isLoadedSectionImage, setIsLoadedSectionImage] = useState(false)
    const [sectionImages, setSectionImage] = useState([])
    const [noSectionImage, setNoSectionImage] = useState(false)

    useEffect(() => {
        setSectionData(props.data)
    }, [props.data])

    useEffect(() => {
        getSectionImages(props.cid, props.data.id)
    }, [props.data.id])

    const getSectionImages = (cid, sectionID) => {
        setIsLoadedSectionImage(false)
        setNoSectionImage(false)
        db.collection('Community')
            .doc(cid)
            .collection('Report')
            .doc(sectionID)
            .collection('Images')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allImages = []
                    docs.forEach(doc => {
                        allImages.push({
                            id: doc.id,
                            ...doc.data()
                        })
                    })
                    setSectionImage(allImages)
                    setIsLoadedSectionImage(true)
                } else {
                    setNoSectionImage(true)
                    setIsLoadedSectionImage(true)
                }
            })
            .catch(err => console.log(err))
    }

    const addFeature = () => {
        let data = {
            id: uuidv4(),
            content: newFeatureText,
            order: sectionData.ListItem.length + 1
        }
        let newSectionData = {
            ...sectionData,
            ListItem: sectionData.ListItem.concat(data)
        }
        props.updateSectionData(props.data.id, newSectionData)
        // setSectionData(newSectionData)
        setNewFeatureText('')
    }

    const removeFeature = (id) => {
        let newSectionData = {
            ...sectionData,
            ListItem: sectionData.ListItem.filter(el => el.id !== id)
        }
        setSectionData(newSectionData)
    }

    const getDetail = () => {
        setNoItem(false)
        db.collection('Community')
            .doc(props.cid)
            .collection('Report')
            .doc(props.data.id)
            .collection('Detail')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    let allDetail = []
                    docs.forEach(doc => {
                        allDetail.push({
                            id: doc.id,
                            ...doc.data()
                        })
                    })
                    setDetail(allDetail)
                    setIsLoadedDetail(true)
                } else {
                    setNoItem(true)
                    setIsLoadedDetail(true)
                }
            })
            .catch(err => console.log(err))
    }

    const submitNewDetail = () => {
        setIsSubmitting(true)
        if (newDetail.isUpvote === '' || newDetail.content === '') {
            setIsError(true)
        } else {
            setIsError(false)
            db.collection('Community')
                .doc(props.cid)
                .collection('Report')
                .doc(props.data.id)
                .collection('Detail')
                .add(newDetail)
                .then(res => {
                    setIsSubmitted(false)
                    setIsSubmitting(false)
                    let newAllDetail = detail
                    newAllDetail.push(newDetail)
                    setDetail(newAllDetail)

                    //reset
                    setTimeout(() => {
                        setNewDetail({
                            content: '',
                            createDate: new Date(),
                            createUserID: props.auth.uid,
                            isAdmin: props.isAdmin,
                            isUpvote: null
                        })
                    }, 500)

                })
                .catch(err => console.log(err))
        }

    }

    const fileCompress = (file) => {
        return new Promise(async (resolve, reject) => {
            new Compressor(file, {
                file: 'blob',
                quality: 0.35,
                maxWidth: 384,
                maxHeight: 216,
                width: 384,
                height: 216,
                success(result) {
                    return resolve({
                        success: true,
                        file: result
                    })
                },
                error(err) {
                    return resolve({
                        success: false,
                        message: err.message
                    })
                },
            })
        })
    }

    const createImageThumbnail = (fileKey, file, communityID) => {
        return new Promise(async (resolve, reject) => {
            const compressState = await fileCompress(file)
            if (compressState.success) {
                let imageRef = firebase.storage().ref('Community/' + communityID + '/Thumbnail/' + fileKey)
                imageRef
                    .put(compressState.file)
                    .then(async (snapshot) => {
                        resolve({
                            success: true,
                        })
                    })
                    .catch(err => {

                    })
            }
        })
    }

    const setImageLibraryRecord = (downloadLink, thumbnailUrl, imageKey, communityID, sectionID) => {

        return new Promise((resolve, reject) => {
            db.collection('Community')
                .doc(communityID)
                .collection("Report")
                .doc(sectionID)
                .collection('Images')
                .doc(imageKey)
                .set({
                    url: downloadLink,
                    thumbnailUrl: thumbnailUrl,
                    createDate: new Date()
                })
                .then(res => {
                    setIsUploading(false)
                    resolve({
                        success: true,
                        data: {
                            id: imageKey,
                            url: downloadLink,
                            thumbnailUrl: thumbnailUrl,
                            createDate: new Date()
                        }
                    })

                })
        })
    }

    const setFileToUpload = () => {
        setIsUploading(true)
        let allPromise = []
        let processedData = []
        selectedFileList.map(img => {
            allPromise.push(
                new Promise(async (resolve, reject) => {
                    setIsSubmitting(true)
                    const key = img.id
                    const file = img.file
                    console.log(key, file, props.cid, props.data.id)
                    const fileType = file.name.split('.')[file.name.split('.').length - 1]
                    const createState = await createImageThumbnail(key, file, props.cid)
                    if (createState.success) {
                        let storageRef = firebase.storage().ref('Community/' + props.cid + '/Report/' + props.data.id + "/")
                        let imageRef = storageRef.child(key);
                        imageRef
                            .put(file)
                            .then(async (snapshot) => {
                                const getThumbnailState = await getDownloadLink('Community/' + props.cid + '/Thumbnail/' + key)
                                const getState = await getDownloadLink('Community/' + props.cid + '/Report/' + props.data.id + "/" + key)
                                if (getState.success && getThumbnailState.success) {
                                    const uploadState = await setImageLibraryRecord(getState.downloadLink, getThumbnailState.downloadLink, key, props.cid, props.data.id)
                                    if (uploadState.success) {
                                        processedData.push(uploadState.data)
                                        resolve()
                                    }
                                }

                            })
                            .catch(err => {

                            });
                    }
                })
            )
        })

        Promise.all(allPromise)
            .then(res => {
                console.log('done!')
                let newSectionImage = sectionImages.concat(processedData)
                setSectionImage(newSectionImage)
                setNoSectionImage(false)
                setIsLoadedSectionImage(true)
                setSelectedFileList([])
            })


    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const selectFiles = (e) => {
        setSelectedFileList([])

        let files = e.target.files

        if (files !== null) {
            let newFileList = []
            let allNewFile = []
            Array.from(files).forEach(file => {
                newFileList.push(
                    new Promise(async (resolve, reject) => {
                        const base64 = await toBase64(file)
                        allNewFile.push({
                            img: base64,
                            file: file,
                            id: uuidv4()
                        })
                        resolve()
                    })
                )
            });

            Promise.all(newFileList)
                .then(res => {
                    setSelectedFileList(allNewFile)
                })

        } else {
            console.log(files)
        }
    }

    const removeImage = (id) => {
        let newArr = selectedFileList
        newArr = newArr.filter(e => e.id !== id)
        setSelectedFileList(newArr)
    }

    const removeUploadedImage = (id) => {
        let newArr = sectionImages
        newArr = newArr.filter(e => e.id !== id)
        setSectionImage(newArr)
    }

    const removeImageFromDB = async (id) => {
        const removeState = await removeFileFromStorage(props.cid, props.data.id, id)
        if (removeState.success) {
            removeUploadedImage(id)
        }
    }

    const removeDetail = (id) => {
        db.collection('Community')
            .doc(props.cid)
            .collection('Report')
            .doc(props.data.id)
            .collection('Detail')
            .doc(id)
            .delete()
            .then(res => {
                let newAllDetail = detail
                newAllDetail = newAllDetail.filter(e => e.id !== id)
                setDetail(newAllDetail)
            })
    }

    useImperativeHandle(ref, () => ({
        returnData() {
            return sectionData
        }
    }))

    if (props.isEditMode) {
        return (
            <div className={classes.ReportSectionCard}>
                <div className={classes.Order}>
                    {
                        props.index !== 0 &&
                        <button onClick={() => props.sortUp(sectionData.id)}>
                            <FontAwesomeIcon icon={faSortUp}/>
                        </button>
                    }
                    {
                        props.sectionLength - 1 !== props.index &&
                        <button onClick={() => props.sortDown(sectionData.id)}>
                            <FontAwesomeIcon icon={faSortDown}/>
                        </button>
                    }

                </div>
                <div className={classes.ReportContainer}>
                    <div className={classes.SectionTitle}>
                        <MDBInput value={sectionData.topicName} onChange={(e) => {
                            props.updateSectionDataValue(props.data.id, "topicName", e.target.value)

                        }}>
                        </MDBInput>
                        <MDBBtn color='danger' className={classes.RemoveBtn}
                                onClick={(e) => props.deleteSection(sectionData.id)}>
                            刪除這項目
                        </MDBBtn>
                    </div>

                    <div className={classes.IsHeadingContainer}>
                        <label className={classes.Label}>
                            是標題？
                        </label>

                        <input type={'checkbox'} checked={sectionData.isHeading} className={classes.Checkbox}
                               onChange={(e) => {
                                   {

                                       props.updateSectionDataValue(props.data.id, "isHeading", e.target.checked)

                                   }
                               }}
                        />
                    </div>

                    {
                        !sectionData.isHeading &&
                        <>
                            <div className={classes.List}>
                                <ul className={classes.ListGroup}>
                                    {
                                        sectionData.ListItem.map((item, index) => {
                                            return (
                                                <li className={classes.ListItemEdit}>
                                                    <MDBInput value={item.content} onChange={(e) => {
                                                        let newSectionData = {...sectionData}
                                                        newSectionData.ListItem[index] = {
                                                            ...newSectionData.ListItem[index],
                                                            content: e.target.value
                                                        }
                                                        console.log(newSectionData)
                                                        props.updateSectionData(props.data.id, newSectionData)
                                                    }}>
                                                    </MDBInput>
                                                    <button className={classes.DeleteBtn}
                                                            onClick={() => removeFeature(item.id)}>
                                                        <FontAwesomeIcon icon={faTimes}/>
                                                    </button>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                                <div className={classes.AddFeatureContainer}>
                                    <input type='text'
                                           className={classes.AddFeatureInput}
                                           value={newFeatureText}
                                           onChange={(e) => setNewFeatureText(e.target.value)}/>

                                    <button className={classes.AddFeatureBtn} onClick={() => addFeature()}>add feature
                                    </button>
                                </div>

                                <section className={classes.ImagesContainer}>
                                    <h2>
                                        相關圖片
                                    </h2>
                                    <div className={classes.UploadImageContainer}>
                                        <input type={'file'} className={classes.ImageUploader}
                                               disabled={isUploading}
                                               placeholder={"上載圖片"}
                                               id={'uploader'}
                                               accept=".png,.jpg,.svg,.tiff,.bmp"
                                               onChange={async (e) => selectFiles(e)}
                                               multiple
                                        />
                                        <button className={classes.UploadImageBtn}
                                                disabled={isUploading || selectedFileList.length === 0}
                                                onClick={() => {
                                                    setFileToUpload()
                                                }}
                                        >
                                            {isUploading ? <Spinner color='dark'/> : "上載圖片"}
                                        </button>
                                    </div>

                                    <div>
                                        {
                                            selectedFileList.map((file, index) => {
                                                return (
                                                    <div key={file.id} className={classes.ImageContainer}>
                                                        <button className={classes.DeleteImageBtn}
                                                                onClick={() => removeImage(file.id)}>
                                                            X
                                                        </button>
                                                        <img
                                                            className={classes.ImageItem}
                                                            src={file.img}
                                                        />
                                                    </div>
                                                )
                                            })
                                        }


                                    </div>

                                    <div className={classes.ImagesContainer}>
                                        {
                                            isLoadedSectionImage ?
                                                !noSectionImage ?
                                                    sectionImages.map((img) => {
                                                        return (
                                                            <div className={classes.ImageContainer}
                                                                 key={img.id + 'sush'}
                                                                 onClick={async () => {
                                                                     // props.insertSvgImage(img.url)
                                                                 }}
                                                            >
                                                                <button className={classes.DeleteImageBtn}
                                                                        onClick={() => removeImageFromDB(img.id)}>
                                                                    X
                                                                </button>
                                                                <ProgImg
                                                                    src={img.thumbnailUrl}
                                                                    conf={{isLazy: false}}
                                                                    className={classes.ImageItem}
                                                                />
                                                            </div>
                                                        )
                                                    })
                                                    : <div className={classes.NoImage}> 沒有相關圖片</div>
                                                :
                                                <ContentLoader
                                                    speed={0.5}
                                                    width={"100%"}
                                                    height={135}
                                                    backgroundColor="#f3f3f3"
                                                    foregroundColor="#ecebeb"

                                                >
                                                    <rect x="5" y="0" rx="8" ry="8" width={100} height={100}/>
                                                    <rect x="115" y="0" rx="8" ry="8" width={100} height={100}/>
                                                    <rect x="225" y="0" rx="8" ry="8" width={100} height={100}/>

                                                </ContentLoader>
                                        }
                                    </div>
                                </section>


                            </div>
                            <button
                                color="primary"
                                onClick={() => {
                                    setIsCollapse(!isCollapse)
                                    getDetail()
                                }}
                                className={classes.CollspseBtn}
                            >

                                {isCollapse ? <FontAwesomeIcon icon={faChevronUp}/> :
                                    <FontAwesomeIcon icon={faChevronDown}/>}
                                了解更多
                            </button>
                            <div className={classes.DetailContainer}>
                                <MDBCollapse id="basicCollapse" isOpen={isCollapse}>
                                    {
                                        isLoadedDetail ?
                                            !noItem ?
                                                detail.map((e, index) => {
                                                    return (
                                                        <DetailCard
                                                            key={'dc' + index}
                                                            data={e}
                                                            isEditMode={props.isEditMode}
                                                            removeDetail={removeDetail}
                                                        />
                                                    )
                                                })
                                                :
                                                <div className={classes.NoItem}>
                                                    找不到評價
                                                </div>
                                            : 'loading...'
                                    }

                                    {
                                        isCreateNewDetail ?
                                            <div className={classes.NewDetailContainer}>
                                                <div className={classes.Title}>新增評價</div>
                                                {
                                                    isError &&
                                                    <MDBAlert color='danger'>
                                                        你必須填寫內容及評分
                                                    </MDBAlert>
                                                }
                                                <div className={classes.NewDetailGrid}>

                                                    <div className={classes.VoteContainer}>
                                                        <button
                                                            className={classes.VoteBtn}
                                                            onClick={() => setNewDetail({
                                                                ...newDetail,
                                                                isUpvote: true
                                                            })}>
                                                            <FontAwesomeIcon
                                                                className={newDetail.isUpvote === true ? classes.UpVote : classes.NoSelect}

                                                                icon={faThumbsUp}/>
                                                        </button>
                                                        <button
                                                            className={classes.VoteBtn}
                                                            onClick={() => setNewDetail({
                                                                ...newDetail,
                                                                isUpvote: null
                                                            })}>
                                                            <FontAwesomeIcon
                                                                className={newDetail.isUpvote !== true && newDetail.isUpvote !== false ? classes.Nature : classes.NoSelect}

                                                                icon={faCircle}/>
                                                        </button>
                                                        <button
                                                            className={classes.VoteBtn}
                                                            onClick={() => setNewDetail({
                                                                ...newDetail,
                                                                isUpvote: false
                                                            })}>
                                                            <FontAwesomeIcon
                                                                className={newDetail.isUpvote === false ? classes.DownVote : classes.NoSelect}
                                                                icon={faThumbsDown}
                                                            />
                                                        </button>
                                                    </div>

                                                    <div>
                                            <textarea className={classes.CommentTextbox}
                                                      placeholder={'你的評價'}
                                                      value={newDetail.content}
                                                      onChange={(e) => {
                                                          setNewDetail({
                                                              ...newDetail,
                                                              content: e.target.value
                                                          })
                                                      }
                                                      }/>
                                                    </div>
                                                </div>
                                                <div className={classes.NewDetailFooter}>
                                                    <MDBBtn color='secondary' className={classes.SubmitBtn}
                                                            disabled={isSubmitting}
                                                            onClick={(e) => submitNewDetail()}
                                                    >
                                                        {isSubmitting ? <Spinner color="light"/> : "發送"}
                                                    </MDBBtn>
                                                </div>
                                            </div>
                                            :
                                            <button
                                                color="primary"
                                                onClick={() => {
                                                    setIsCreateNewDetail(true)
                                                }}
                                                className={classes.CollspseBtn}
                                            >
                                                新增評價
                                            </button>
                                    }

                                </MDBCollapse>
                            </div>
                        </>
                    }
                </div>
            </div>
        )
    } else if (sectionData.isHeading) {
        return (
            <section className={classes.ReportSection}>
                <h2 className={classes.HeadingTitle}>
                    {sectionData.topicName}
                </h2>
                <hr/>
            </section>
        )
    } else {
        return (
            <section className={classes.ReportSection}>
                <h3 className={classes.SectionTitle}>
                    {sectionData.topicName}
                </h3>

                <div className={classes.List}>

                    <ul className={classes.ListGroup}>
                        {
                            sectionData.ListItem.map((item, index) => {
                                return (
                                    <li className={classes.ListItem}>
                                        <FontAwesomeIcon icon={faCircle}/> {item.content}
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>

                {
                    isLoadedSectionImage ?
                        !noSectionImage ?
                            <div className={classes.ImagesContainer}>
                                {
                                    sectionImages.map((img) => {
                                        return (
                                            <div className={classes.ImageContainer} key={img.id + 'sush'}
                                                 onClick={async () => {
                                                     // props.insertSvgImage(img.url)
                                                 }}
                                            >

                                                <ProgImg
                                                    src={img.thumbnailUrl}
                                                    conf={{isLazy: false}}
                                                    className={classes.ImageItem}
                                                />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            : ''
                        :
                        <ContentLoader
                            speed={0.5}
                            width={"100%"}
                            height={135}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"

                        >
                            <rect x="5" y="0" rx="8" ry="8" width={100} height={100}/>
                            <rect x="115" y="0" rx="8" ry="8" width={100} height={100}/>
                            <rect x="225" y="0" rx="8" ry="8" width={100} height={100}/>

                        </ContentLoader>
                }

                <button
                    color="primary"
                    onClick={() => {
                        setIsCollapse(!isCollapse)
                        getDetail()
                    }}
                    className={classes.CollspseBtn}
                >

                    {isCollapse ? <FontAwesomeIcon icon={faChevronUp}/> : <FontAwesomeIcon icon={faChevronDown}/>}
                    了解更多
                </button>
                <div className={classes.DetailContainer}>
                    <MDBCollapse id="basicCollapse" isOpen={isCollapse}>
                        {
                            isLoadedDetail ?
                                !noItem ?
                                    detail.map((e, index) => {
                                        return (
                                            <DetailCard key={'dc' + index} data={e}/>
                                        )
                                    })
                                    :
                                    <div className={classes.NoItem}>
                                        找不到評價
                                    </div>
                                : 'loading...'
                        }

                        {
                            isCreateNewDetail ?
                                <div className={classes.NewDetailContainer}>
                                    <div className={classes.Title}>新增評價</div>
                                    {
                                        isError &&
                                        <MDBAlert color='danger'>
                                            你必須填寫內容及評分
                                        </MDBAlert>
                                    }
                                    <div className={classes.NewDetailGrid}>

                                        <div className={classes.VoteContainer}>
                                            <button
                                                className={classes.VoteBtn}
                                                onClick={() => setNewDetail({
                                                    ...newDetail,
                                                    isUpvote: true
                                                })}>
                                                <FontAwesomeIcon
                                                    className={newDetail.isUpvote === true ? classes.UpVote : classes.NoSelect}

                                                    icon={faThumbsUp}/>
                                            </button>
                                            <button
                                                className={classes.VoteBtn}
                                                onClick={() => setNewDetail({
                                                    ...newDetail,
                                                    isUpvote: null
                                                })}>
                                                <FontAwesomeIcon
                                                    className={newDetail.isUpvote !== true && newDetail.isUpvote !== false ? classes.Nature : classes.NoSelect}

                                                    icon={faCircle}/>
                                            </button>
                                            <button
                                                className={classes.VoteBtn}
                                                onClick={() => setNewDetail({
                                                    ...newDetail,
                                                    isUpvote: false
                                                })}>
                                                <FontAwesomeIcon
                                                    className={newDetail.isUpvote === false ? classes.DownVote : classes.NoSelect}
                                                    icon={faThumbsDown}
                                                />
                                            </button>
                                        </div>

                                        <div>
                                            <textarea className={classes.CommentTextbox}
                                                      placeholder={'你的評價'}
                                                      value={newDetail.content}
                                                      onChange={(e) => {
                                                          setNewDetail({
                                                              ...newDetail,
                                                              content: e.target.value
                                                          })
                                                      }
                                                      }/>
                                        </div>
                                    </div>
                                    <div className={classes.NewDetailFooter}>
                                        <MDBBtn color='secondary' className={classes.SubmitBtn}
                                                disabled={isSubmitting}
                                                onClick={(e) => submitNewDetail()}
                                        >
                                            {isSubmitting ? <Spinner color="light"/> : "發送"}
                                        </MDBBtn>
                                    </div>
                                </div>
                                :
                                <button
                                    color="primary"
                                    onClick={() => {
                                        setIsCreateNewDetail(true)
                                    }}
                                    className={classes.CollspseBtn}
                                >
                                    新增評價
                                </button>
                        }

                    </MDBCollapse>
                </div>

            </section>
        )
    }

}
export default React.forwardRef(ReportSection)